import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
import { DebugConsole } from './components/DebugConsole';
import { initDebugBus } from './lib/debugBus';
import { DEBUG_MODE } from './lib/api';
import './index.css';

// Start capturing browser errors, unhandled rejections, console output and API
// failures as early as possible when the APP_DEBUG master switch is on.
if (DEBUG_MODE) {
  initDebugBus();
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
      {DEBUG_MODE && <DebugConsole />}
    </ErrorBoundary>
  </React.StrictMode>
);
